import { Routes } from '@angular/router';
import { PageKey } from '../../../../shared/services/page/models/page.key';

export const iatfRoutes: Routes = [{
  path: 'iatf',
  loadComponent: () => import('./iatf.component').then(m => m.IatfComponent),
  children: [
    {
      path: '',
      loadComponent: () => import('./list/list.component').then(m => m.ListIatfComponent),
      data: {
        title: 'Visualizar Normas',
        key: PageKey.MANAGE,
        fullscreen: true
      },
    },
    {
      path: 'history',
      loadComponent: () => import('./history/history.component').then(m => m.IatfHistoryComponent),
      data: {
        title: 'Histórico de Normas',
        key: PageKey.MANAGE,
        fullscreen: true
      },
    },
  ]
}];
